import React, { Component } from 'react';
import axios from 'axios';
import ReactGA from 'react-ga';
import 'react-router-dom';
import '../styles/sayhello.css';

const ROOT_URL = 'https://78t074alpe.execute-api.us-east-1.amazonaws.com';

class SayHelloPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      description: '',
      nameValid: false,
      emailValid: false,
      descriptionValid: false,
      formValid: false,
      formError: '',
      nameError: '',
      emailError: '',
      descriptionError: '',
      fieldName: '',
      error: '',
    };
  }
  componentDidMount() {
    this.renderButton();
  }

  componentDidReceiveProps(event) {
    this.onInput(event, () => this.renderButton());
  }
  onInput(event, blur = null) {
    if (event.target === undefined) {
      return null;
    } else {
      const { className, value } = event.target;
      const classError = className + 'Error';
      const classValid = className + 'Valid';
      const validateClass = className + 'Validate';
      if (blur) {
        this.setState({ fieldName: validateClass });
      } else {
        this.setState({ fieldName: className }, () => {
          return this.onValid();
        });
      }
      const errorMessages = {
        nameError: 'Please enter your name.',
        emailError: 'Please enter a valid email.',
        descriptionError: 'Please tell us a little about your project.',
        formError: 'All fields are required.',
      };
      this.setState(
        { [className]: value, formError: '', [classError]: '' },
        () => {
          // test if input is valid
          // Check for empty
          const currentField = this.state[className];
          if (currentField.length > 0) {
            if (this.state.fieldName.includes('Validate')) {
              if (className.includes('name')) {
                this.setState({ nameValid: true }, () => {
                  return this.onValid();
                });
              }
              if (className.includes('email')) {
                const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!emailRegex.test(currentField)) {
                  this.setState({
                    [classError]: errorMessages[classError],
                    emailValid: false,
                  });
                } else {
                  this.setState({ emailValid: true }, () => {
                    return this.onValid();
                  });
                }
              }
              if (className.includes('description')) {
                this.setState({ descriptionValid: true }, () => {
                  return this.onValid();
                });
              }
            } else {
              return this.onValid();
            }
          } else {
            this.setState(
              {
                formError: errorMessages.formError,
                [classError]: errorMessages[classError],
                [classValid]: false,
              },
              () => {
                return this.onValid();
              }
            );
          }
        }
      );
    }
  }
  onValid() {
    const { nameValid, emailValid, descriptionValid } = this.state;
    if (nameValid && emailValid && descriptionValid) {
      this.setState({ formValid: true }, () => {
        return this.renderButton();
      });
    } else {
      this.setState({ formValid: false }, () => {
        return this.renderButton();
      });
    }
  }

  renderButton() {
    const { formValid } = this.state;
    return (
      <button
        disabled={!formValid}
        type="submit"
        aria-label="Send"
        className="submitButton"
      >
        Send <i className="fa fa-paper-plane" />
      </button>
    );
  }
  onSend(event) {
    event.preventDefault();
    ReactGA.event({
      category: 'Contact',
      action: 'Sent form',
      label: 'Contact Sent',
    });
    const url = `${ROOT_URL}/mail`;
    axios
      .post(url, {
        name: event.target[0].value,
        email: event.target[1].value,
        message: event.target[2].value,
      })
      .then(response => {
        this.props.history.push('/', {
          query: '?msg',
          state: { thanksSent: true },
        });
      })
      .catch(err => {
        this.setState({
          error:
            'Something went wrong with the mail server. Please try again in a few minutes.',
        });
      });
  }
  render() {
    const {
      name,
      email,
      description,
      formError,
      nameError,
      emailError,
      descriptionError,
      error,
    } = this.state;
    return (
      <div className="helloContainer">
        <h1>Say Hello</h1>
        <form className="contactForm" onSubmit={this.onSend.bind(this)}>
          <div className="formBody">
            <div className="inputArea">
              <span className="errorMessage">{nameError}</span>
              <input
                type="text"
                className="name"
                placeholder="Name"
                aria-label="Name"
                value={name}
                onChange={event => this.onInput(event)}
                onBlur={event => this.onInput(event, 'blur')}
              />
              <span className="errorMessage">{emailError}</span>
              <input
                type="text"
                className="email"
                placeholder="Email"
                aria-label="Email"
                value={email}
                onChange={event => this.onInput(event)}
                onBlur={event => this.onInput(event, 'blur')}
              />
              <span className="errorMessage">{descriptionError}</span>
            </div>
            <textarea
              className="description"
              placeholder="Tell us a little about the project."
              aria-label="Tell us a little about the project."
              cols="60"
              rows="20"
              value={description}
              onChange={event => this.onInput(event)}
              onBlur={event => this.onInput(event, 'blur')}
            />
          </div>
          <p className="errorMessage">{formError}</p>
          {this.renderButton()}
          <p className="errorMessage">{error}</p>
        </form>
      </div>
    );
  }
}

export default SayHelloPage;



// WEBPACK FOOTER //
// ./src/containers/sayHello.js